<template>
    <!-- 
    1.화면ID      : MCF_AM_001
    2.화면명      : 영업기회 알림
    3.작성자      : 김찬종 차장
    4.화면설명    : 영업기회 메일 알람결과를 조회한다.
    5.Descrition : 2024.04.02 최초작성
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->
    
    <div class="content-wrap">
      <div>
        <!-- 검색 영역 시작 -->
        <div class="search-wrap">
          <div class="row">
            <div class="col-md-2">
              <div class="mb-3">
                <ElLabel name="알람구분">
                  <template #end>
                    <ElSelect v-model="state.searchParams.alarm_id" :options="state.alarmList"/>
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <ElLabel name="영업기회ID">
                  <template #end="{id}">
                    <ElInput :id="id" v-model="state.searchParams.sales_id" @inputKeyupEnter="onSearch"/>
                  </template>

                </ElLabel>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <ElLabel name="발신상태">
                  <template #end>
                    <ElSelect v-model="state.searchParams.rst_yn" :options="state.rstYnList"/>
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <ElLabel name="등록일자"/>
                <div class="d-flex">
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.fr_date = r" v-model="state.searchParams.fr_date"/>
                  <span class="tilde">~</span>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.to_date = r" v-model="state.searchParams.to_date"/> 
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 검색 영역 종료 -->
        <div class="search-detail-wrap"></div>
        <div class="text-end py-2">
          <ElButton type="search" @buttonClick="onSearch()">검색</ElButton>
        </div>
        <!-- 그리드 영역 시작 -->
        <div class="table-responsive table-list table-cf">
          <DataTable
              :value="state.gridRowData"
              v-model:selection="state.selectRow" selectionMode="single"
              paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
              scrollable scrollHeight="400px"
              stripedRows
              @rowSelect="onRowSelect">
              <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
              <Column field="row_no" header="NO" style="min-width:4rem;"></Column>
              <Column field="alarm_nm" header="알람구분" style="min-width:8rem"></Column>
              <Column field="sales_id" header="영업기회ID" style="min-width:10rem"></Column>
              <Column field="sales_nm" header="영업기회명" style="min-width:20rem;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"></Column>
              <Column field="title" header="제목">
                <template #body="{data,field}">
                  <div :title="data[field]" style="max-width:25rem; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;">{{ data[field] }}</div>
                </template>
              </Column>
              <Column field="snd_id" header="수신자ID" style="min-width:6rem"></Column>
              <Column field="snd_nm" header="수신자명" style="min-width:6rem"></Column>
              <Column field="rst_nm" header="발신상태" style="min-width:6rem"></Column>
              <Column field="snd_dt" header="발신일자" style="min-width:8rem"></Column>
              <Column field="reg_dt" header="등록일자" style="min-width:8rem"></Column>
          </DataTable>
        </div>
        <!-- 그리드 영역 종료 -->
        <div class="text-end py-2">

        </div>


<div class="modal fade" id="emailModal" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="false">
<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
<div class="modal-content">
<div class="modal-header">
  <h1 class="modal-title fs-6" id="emailModalLabel">알람결과 상세</h1>
  <ElButton type="modelHeaderClose"></ElButton>
</div>
<div class="modal-body">
  <div class="register-wrap">

    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <ElLabel name="수신자ID">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.snd_id" disabled = "true" />
            </template>
          </ElLabel>
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <ElLabel name="수신자명">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.snd_nm" disabled = "true" />
            </template>
          </ElLabel>
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <ElLabel name="메일주소">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.snd_email" disabled = "true" />
            </template>
          </ElLabel>
          
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">

          <ElLabel name="발신상태">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.rst_nm" disabled = "true" />
            </template>
          </ElLabel>

        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <ElLabel name="발신일자">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.snd_dt" disabled = "true" />
            </template>
          </ElLabel>


        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <ElLabel name="등록일자">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.reg_dt" disabled = "true" />
            </template>
          </ElLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <ElLabel name="제목">
            <template #end="{id}">
              <ElInput :id="id" v-model="email.title" disabled = "true" />
            </template>
          </ElLabel>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <ElLabel name="내용">
            <template #end="{id}">
              <ElTextarea v-model="email.content" :id="id" :rows="10" disabled/>
            </template>
          </ElLabel>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <ElLabel name="오류내용">
            <template #end="{id}">
              <ElTextarea v-model="email.error_msg" :id="id" :rows="10" disabled/>
            </template>
          </ElLabel>

        </div>
      </div>
    </div>

  </div>
  <div class="table-responsive table-list">
    <!--grid 영역-->
  </div>
</div>
<div class="modal-footer">
  <ElButton type="modelFooterClose"@buttonClick="closeModal()">닫기</ElButton>
</div>
</div>
</div>
</div>


      </div>
    </div>
    <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#emailModal" ref="emailModalRef"/>
  </template>
       
  <script setup>   
    import {reactive,ref,onBeforeMount,onMounted,computed} from 'vue';
    import api            from '@/utils/api';
    import DatePicker     from '@/components/common/DatePicker';
    import common         from '@/js/common';
    import DataTable      from 'primevue/datatable';
    import Column         from 'primevue/column';

    import { useLoading } from '@/composable/Loading.js'
    const { setIsLoading } = useLoading()
    import { alarmRsltList } from '@/api/batch';
    const email = ref({});
    const emailModalRef = ref();

    /** 검색기간 초기화 */
    const today = new Date();
    const frday = common.addMonth(today, -1);

    const frDate = common.dateFormat(frday);
    const toDate = common.dateFormat(today);

    onBeforeMount(() => {
  
    });
  
    onMounted(async () => {
      state.searchParams.alarm_id = "All";
      state.searchParams.rst_yn = "All";
      state.searchParams.fr_date = frDate;
      state.searchParams.to_date = toDate;
      await onSearch();
    });
  
    //변수 선언 영역 
    const state = reactive({
        gridRowData :[],
        selectRow : null,
        searchParams : {
            alarm_id   : '',
            sales_id   : '',
            rst_yn     : '',
            fr_date    : '',
            to_date    : '',
            page_count : 1,
            unit_count : 100000
        },
        alarmList : [
                    {text: '전체', value: 'All'},
                    {text: 'Warranty 알람', value: 'w'},
                    {text: '지급일 알람', value: 'p'}
                  ],
        rstYnList : [
                    {text: '전체', value: 'All'},
                    {text: '발신대기', value: 'N'},
                    {text: '발신성공', value: 'Y'},
                    {text: '발신실패', value: 'F'}
                  ]
    });
  
    const onSearch = async () => {
      try {
        setIsLoading(true)
        const res = await alarmRsltList(state.searchParams)
        state.gridRowData = res.rtn;
      } catch (err) {
        alert("전송 중 에러가 발생하였습니다.");
      } finally {
        setIsLoading(false)
      }
    };
    
    const onRowSelect = (event) => {
      if(event.type == 'row') {
        email.value = {...event.data};
        emailModalRef.value.input.click();
      }
    };

    const closeModal = () => {
      emailModalRef.value.input.click();
      email.value = {};
    };
  </script>
  